import { CaseStudyTestimonialComponent } from './CaseStudyTestimonial';
export default CaseStudyTestimonialComponent;
